<template>
  <div class="flex flex_col qxm-page">
    <!-- 上面的下拉选择 -->
    <div class="flex flex_a_c sf-selects">
      <img class="sf_icon" src="@/assets/image/qx/icon_small.png" alt="" />
      <el-form
        class="sf-form warnform-inline"
        :inline="true"
        ref="selectForm"
        :model="selectForm"
      >
        <el-form-item
          label="选择生产区域"
          style="margin-bottom: 0"
          v-if="isShowAllSelect"
        >
          <el-select
            v-model="allOrgId"
            :placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
            @change="changeAllOrg"
          >
            <el-option
              v-for="(item, index) in orgAllSelect"
              :key="index"
              :value="item.orgId"
              :label="item.orgName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="isShowAllSelect ? '' : '选择气象监测站点'">
          <el-select
            v-model="selectForm.facId"
            @change="changeFacid"
            :placeholder="orgSelect.length ? '请选择' : '暂无设备'"
          >
            <el-option
              v-for="(item, index) in orgSelect"
              :key="index"
              :value="item.facId"
              :label="item.facName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的内容数据 -->
    <div class="flex flex_col page-content" v-loading="loading">
      <div class="page-top">
        <title-model titles="气象实时监测">
          <div
            class="font_14 c_six"
            v-if="!isWarn && isorgSelectData && isinfoListData"
          >
            采集时间：{{ infoData.dataTime }}
          </div>
          <!-- 设备异常 -->
          <div
            class="flex flex_a_c"
            v-if="isorgSelectData && (isWarn || !isinfoListData)"
          >
            <img
              class="icon_warn"
              src="@/assets/image/home/icon_warn.png"
              alt=""
            />
            <span class="font_14 c_six">设备异常！</span>
          </div>
        </title-model>
        <!-- 上面的状态 -->
        <div class="flex">
          <img class="sf-logo" src="@/assets/image/qx/icon_big.png" alt="" />
          <!-- 右边指令状态 -->
          <div class="sf-right">
            <!-- 下面的指令数据 -->
            <div class="status-wrap" v-if="isorgSelectData">
              <ul class="status-ul">
                <li
                  class="status-li"
                  v-for="(item, index) in infoList"
                  :key="index"
                >
                  <div class="flex flex_col flex_ju_c flex_a_c status-div">
                    <img class="status-img" :src="item.path" alt="" />
                    <span class="font_16 status-name">{{ item.name }}</span>
                    <div class="bold">
                      <span class="font_24">{{ item.value }}</span>
                      <span class="font_16">{{ item.unitName }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="table-empty bottom-empty table-empty-big" v-else>
              <img
                class="table-noimg"
                src="@/assets/image/sf/empty.png"
                v-show="!orgSelect.length"
                alt=""
              />
              <img
                class="table-noimg-data"
                src="@/assets/image/home/img_none.png"
                v-show="orgSelect.length"
                alt=""
              />
              <!-- <img v-show="!infoList.length" class="table-noimg" src="@/assets/image/sf/empty.png" alt="" /> -->
              <div class="table-emptyword">
                <span v-if="!orgSelect.length">该网点暂无气象设备!</span
                ><span v-else>暂无数据</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 下面的执行命令 -->
      <div class="page-bottom" v-if="orgSelect.length && infoList.length">
        <title-model titles="气象统计数据">
          <!-- 右侧的表单 -->
          <div class="right-form">
            <el-form
              :model="queryParam"
              :inline="true"
              ref="ruleForm"
              class="qxb-form warnform-inline"
            >
              <el-form-item label="">
                <el-select placeholder="请选择" v-model="queryParam.listparam">
                  <el-option
                    v-for="(item, index) in itemSelect"
                    :key="index"
                    :label="item.itemName"
                    :value="item.itemCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" class="form-picker">
                <div class="picker-divs picker-divs-more">
                  <el-date-picker
                    v-model="queryParam.startTime"
                    size="small"
                    type="datetime"
                    placeholder="选择日期"
                    popper-class="pick-poper"
                    class="picker-div"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    prefix-icon=" "
                    clear-icon="el-icon-date"
                    :clearable="false"
                    :picker-options="pickerOptions0"
                    :editable="false"
                  >
                  </el-date-picker>
                  <i class="pick-icon el-icon-date"></i>
                  <i class="pick-icon-yuan el-icon-time"></i>
                </div>

                <span class="pick-word">至</span>
                <div class="picker-divs picker-divs-more">
                  <el-date-picker
                    v-model="queryParam.endTime"
                    size="small"
                    type="datetime"
                    placeholder="选择日期"
                    popper-class="pick-poper"
                    class="picker-div"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    prefix-icon=" "
                    clear-icon="el-icon-date"
                    :clearable="false"
                    :picker-options="pickerOptions1"
                    :editable="false"
                  >
                  </el-date-picker>
                  <i class="pick-icon el-icon-date"></i>
                  <i class="pick-icon-yuan el-icon-time"></i>
                </div>
              </el-form-item>
              <el-form-item class="form-btns">
                <el-button type="primary" @click="searchTap">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </title-model>
        <!-- 气象折线图 -->
        <div class="qx-charts" ref="chartLine" v-show="isShowLine"></div>
        <div
          class="
            table-empty
            qx-charts
            table-empty-big
            flex flex_col flex_a_c flex_ju_c
          "
          v-show="!isShowLine"
        >
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无气象数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 气象监测
 */
import titleModel from "@/components/title-model.vue";
import tableMinin from "@/mixins/TableMinin";
import qixiangJs from "./lib/qixiang";
import {
  todayTime,
  GetPreMonthDay,
  GetNextMonthDay,
  getFormatDate,
} from "../../times/moment";
import { iconList } from "@/assets/json/img.js";
export default {
  components: { titleModel },
  mixins: [tableMinin, qixiangJs],
  data() {
    return {
      // 时间是否初始化
      isMakeTime: false,
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid

      // 上面的监测站点选择表单
      orgSelect: [], // 上面的下拉选数据
      isorgSelectData: true, //是否有监测站点下拉数据----默认为true解决首次进入页面显示暂无数据
      selectForm: {
        facId: "",
      },
      infoData: {}, // 详情总数据
      infoList: [], // 详情列表数据
      isinfoListData: true, //是否有详情列表数据
      imgList: [
        {
          key: "WD",
          path: require("@/assets/image/production/icons_kw.png"),
        },
        {
          key: "SD",
          path: require("@/assets/image/production/icons_ks.png"),
        },
        {
          key: "VOLTAGE",
          path: require("@/assets/image/qx/icon_ya.png"),
        },
        {
          key: "TRSDA",
          path: require("@/assets/image/qx/icon_qx.png"),
        },
        {
          key: "TRSDB",
          path: require("@/assets/image/qx/icon_qx.png"),
        },
        {
          key: "TRSDC",
          path: require("@/assets/image/qx/icon_qx.png"),
        },
        {
          key: "TRSDD",
          path: require("@/assets/image/qx/icon_qx.png"),
        },
        {
          key: "TRWDA",
          path: require("@/assets/image/qx/icon_wd.png"),
        },
        {
          key: "TRWDB",
          path: require("@/assets/image/qx/icon_wd.png"),
        },
        {
          key: "TRWDC",
          path: require("@/assets/image/qx/icon_wd.png"),
        },
        {
          key: "TRWDD",
          path: require("@/assets/image/qx/icon_wd.png"),
        },
      ], //图片数组
      isWarn: false, // 是否时异常状态
      // 采集项下拉选
      itemSelect: [],
      url: {
        lineChart: "/napi/index/weatherStationDataChart",
      },
      isShowLine: true, // 是否显示折线图
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  created() {
    this.imgList = iconList;
    console.log(this.imgList);
  },

  mounted() {
    this.$set(this.queryParam, "startTime", `${todayTime()} 00:00:00`);
    this.$set(this.queryParam, "endTime", `${todayTime()} 23:59:59`);

    // this.$set(
    // 	this.imgList['WD'],
    // 	'path',
    // 	require('@/assets/image/production/icons_kw.png')
    // )
    // this.$set(
    // 	this.imgList['SD'],
    // 	'path',
    // 	require('@/assets/image/production/icons_ks.png')
    // )
    this.imgList[1]["path"] = require("@/assets/image/production/icons_kw.png");
    this.imgList[2]["path"] = require("@/assets/image/production/icons_ks.png");

    // this.$set(this.queryParam, 'startTime', `2022-04-05 00:00:00`)
    // this.$set(this.queryParam, 'endTime', `2022-04-14 23:59:59`)

    // 获取头部下拉选
    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      this.getOrgids();
    }
    // this.getOrgids();
    // 获取折线图数据
    // this.getLineData()

    // this.lineChart()
  },
};
</script>
<style lang="scss" scoped>
@mixin scrolls() {
  overflow-y: scroll;
  // 背景
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
    border-radius: 4px;
  }
  // 背景
  &::-webkit-scrollbar-track {
    width: 8px;
    height: 8px;
    background-color: transparent;
    border-radius: 4px;
  }
  // 滚动条
  &::-webkit-scrollbar-thumb {
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: #d9d9d9;
  }
}
.qxm-page {
  height: 100%;
  min-height: 670px;
  // 下拉选
  .sf-selects {
    margin-bottom: 0.13rem;
    .sf_icon {
      width: 0.3rem;
      height: 0.5rem;
    }
    .sf-form {
      display: inline-block;
      padding-left: 0;
      margin-left: 0.21rem;
    }
  }
  .page-content {
    flex: 1;
  }
  // 上面:气象实时监测
  .page-top {
    background: #ffffff;
    border-radius: 0.19rem;
    padding: 0 0.04rem;
    .icon_warn {
      width: 0.25rem;
      margin-right: 0.13rem;
    }
  }
  // 左边
  .sf-logo {
    width: 1.81rem;
    height: 3.5rem;
    margin: 0.25rem 1.15rem 0.38rem;
  }
  // 右边
  .sf-right {
    flex: 1;
    padding-bottom: 0.17rem;

    // 列表
    .status-wrap {
      margin: 0.33rem 0.06rem 0 0;
      //height: 3.55rem;
      // @include scrolls();
      overflow-y: scroll;
      // 背景
      &::-webkit-scrollbar {
        width: 0px;
        height: 8px;
        background-color: transparent;
        border-radius: 4px;
      }
      // 背景
      &::-webkit-scrollbar-track {
        width: 0px;
        height: 8px;
        background-color: transparent;
        border-radius: 4px;
      }
      // 滚动条
      &::-webkit-scrollbar-thumb {
        width: 0px;
        height: 8px;
        border-radius: 4px;
        background-color: #d9d9d9;
      }
      .status-ul {
        width: 100%;
        text-align: left;
        max-height: 3.5875rem;
        overflow: scroll;
        // 背景
        &::-webkit-scrollbar {
          width: 8px;
          height: 0px;
          background-color: transparent;
          border-radius: 4px;
        }
        // 背景
        &::-webkit-scrollbar-track {
          width: 8px;
          height: 8px;
          background-color: transparent;
          border-radius: 4px;
        }
        // 滚动条
        &::-webkit-scrollbar-thumb {
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #d9d9d9;
        }
        .status-li {
          display: inline-block;
          margin-left: 0.17rem;
          margin-top: 0;
          color: #2daea9;
          &:nth-child(n + 9) {
            margin-top: 0.2rem;
          }
          &:nth-child(8n + 1) {
            margin-left: 0;
          }
        }
        .status-div {
          width: 1.79rem;
          height: 1.69rem;
          background: #f2f8f9;
          border-radius: 0.13rem;
          font-family: Microsoft YaHei;
        }
        .status-img {
          width: 0.63rem;
          height: 0.63rem;
        }
        .status-name {
          margin: 0.04rem 0 0.19rem;
        }
      }
    }
    .table-empty {
      margin-top: 0.1rem;
      padding-bottom: 0.587rem;
      .table-noimg {
        width: 4.1rem;
        height: 2.27rem;
      }
      .table-noimg-data {
        width: 3rem;
        height: 2.27rem;
      }
      .table-emptyword {
        margin-left: 0;
        margin-top: 0.75rem;
      }
    }
  }
  // 下面
  .page-bottom {
    background: #ffffff;
    border-radius: 0.19rem;
    margin-top: 0.17rem;
    padding: 0 0.04rem 0;
    flex: 1;
    // 折线图
    .qx-charts {
      width: 100%;
      height: 82%;
    }
    // 表单
    .qxb-form {
      padding: 0;
      .form-picker {
        margin: 0 0.71rem 0 0.44rem;
      }
    }
  }
}
</style>
